module.exports = require('./lib/Observable.js').Observable;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/zen-observable/index.js
// module id = 839
// module chunks = 168707334958949